export const FREE_UPVALUE_INTRO_MODAL_KEY = 'free-upvalue-intro'
export const PAID_UPVALUE_INTRO_MODAL_KEY = 'paid-upvalue-intro'
export const SEED_INTRO_MODAL_KEY = 'seed-intro'
export const BUY_BSV_MODAL_KEY = 'buy-bsv-top-up'
export const LARGE_UPVALUE_CONFIRM_MODAL_KEY = 'large-upvalue-confirm'
